export default __webpack_public_path__ + "static/media/arrow-sider-left.f8eff49d.svg";